import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";

export const ReturnDetails = ({ returnOrder }) => {
  const details = {
    "No.": returnOrder.no,
    Status: returnOrder.status,
    Branch: `${returnOrder.branchName} (${returnOrder.branchNo})`,
    Date: returnOrder.orderDate,
    Reference: returnOrder.returnRef,
    Package: `${returnOrder.packType} * ${returnOrder.packNo}`,
    Total: `£${returnOrder.amount}`,
  };

  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom>
        Details
      </Typography>
      <Grid
        container
        spacing={{ xs: 2, md: 2 }}
        columns={{ xs: 2, sm: 2, md: 3, lg: 2 }}
      >
        {Object.entries(details).map(([key, value], i) => (
          <Grid
            key={key}
            size={{
              xs: 1,
              sm: 1,
              md: 1,
              lg: 1,
            }}
          >
            <TextField
              size="small"
              fullWidth
              id={`${key}-input`}
              label={key}
              value={value || ""}
              slotProps={{
                input: {
                  readOnly: true,
                },
              }}
            />
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
};
